@if (!isDownload) {
  <div class="flex justify-content-between">
    <span class="content-left">&copy; {{currentYear}} EmpiRx Health, LLC. All Rights Reserved. | <a href="/termsAndConditions"  target="_blank" rel="noopener noreferrer">Terms of Use </a> </span>  <span class="content-right">Technical Support: (877) 341-5648</span>
  </div>
}
@if (isDownload) {
  <div class="flex">
    <span class="content-left">&copy; {{currentYear}} EmpiRx Health, LLC. All Rights Reserved. | <a href="{{blobLink}}" download="pdf-test" target="_blank" rel="noopener noreferrer">Download Terms of Use</a> </span>  <span class="content-right">Technical Support: (877) 341-5648</span>
    <!-- &copy; 2021 EmpiRx Health, LLC. All Rights Reserved. | <a href="{{blobLink}}" download="pdf-test" target="_blank" rel="noopener noreferrer">Download Terms of Use</a> | <span>Technical Support: 844-358-3961</span> -->
  </div>
}